import React from "react";
import { Linkedin, Mail, Globe, MapPin, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT } from "../../data/content";

export const Footer = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer className="relative overflow-hidden emerald-radial text-off-white" data-testid="footer">
      <div className="grain absolute inset-0" />
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 py-16 sm:px-8 sm:py-20">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo variant="dark" />
            <p className="mt-6 max-w-sm font-serif text-2xl italic text-off-white/90">
              Strategise • Optimise • Transform
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-off-white/60">
              Operational Excellence · Supply Chain · AI & Digital Transformation · People Development · Career Coaching
            </p>
            <div className="mt-6 flex gap-3">
              <a href={CONTACT.linkedin} target="_blank" rel="noreferrer" data-testid="footer-linkedin" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 transition-colors hover:border-gold hover:text-gold">
                <Linkedin size={18} />
              </a>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 transition-colors hover:border-gold hover:text-gold">
                <Mail size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-gold">Explore</h4>
            <ul className="mt-5 space-y-3 text-sm text-off-white/70">
              {["About", "Services", "AI & Digital", "People", "Career Coaching", "Industries", "Insights", "Contact"].map((x) => (
                <li key={x}>
                  <button onClick={() => go(`#${x.toLowerCase().replace(/ & /g, "-").replace(/ /g, "")}`)} className="transition-colors hover:text-gold">
                    {x}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-gold">Get in touch</h4>
            <ul className="mt-5 space-y-4 text-sm text-off-white/70">
              {CONTACT.phones.map((p) => (
                <li key={p} className="flex items-start gap-3"><Phone size={16} className="mt-0.5 text-emerald-light" />{p}</li>
              ))}
              <li className="flex items-start gap-3"><Mail size={16} className="mt-0.5 text-emerald-light" />{CONTACT.email}</li>
              <li className="flex items-start gap-3"><Globe size={16} className="mt-0.5 text-emerald-light" />{CONTACT.website}</li>
              <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-emerald-light" />{CONTACT.location}</li>
            </ul>
            <p className="mt-5 inline-block rounded-full border border-gold/40 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-gold-light">
              UK & Global Services
            </p>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-8 text-center">
          <p className="font-serif text-3xl tracking-[0.15em] text-off-white">ONWARDTRANSCENDS</p>
          <p className="mt-2 text-sm font-semibold uppercase tracking-[0.3em] text-gradient-gold">Strategise • Optimise • Transform</p>
          <p className="mt-3 font-serif text-xl italic text-off-white/70">Strategic Excellence. Sustainable Impact.</p>
          <p className="mt-6 text-xs text-off-white/40">© {new Date().getFullYear()} OnwardTranscends. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
